export default __webpack_public_path__ + "static/media/006-gingerbread man.38ec3899.svg";